/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SuspectedTradeUser_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SuspectedTradeUserLoader_viewer$ref: FragmentReference;
export type SuspectedTradeUserLoader_viewer = {|
  +$fragmentRefs: SuspectedTradeUser_viewer$ref,
  +$refType: SuspectedTradeUserLoader_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SuspectedTradeUserLoader_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUser_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6c2b2652ee5241978f501171f172d289';
module.exports = node;
